// Este codigo fue generado por Github Copilot Chat
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonSizeEnum, ButtonTypeEnum } from './buttonTypesEnum';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
  @Input() label!: string;
  @Input() disabled = false;
  @Output() handleClick = new EventEmitter();
  @Input() leftIcon?: string;
  @Input() rightIcon?: string;
  @Input() leftIconActive?: string;
  @Input() rightIconActive?: string;
  @Input() type: ButtonTypeEnum = ButtonTypeEnum.PRIMARY;
  @Input() size: ButtonSizeEnum = ButtonSizeEnum.MD;
  @Input() isActive = false;

  onClick() {
    this.handleClick.emit();
  }
}
// Este codigo fue generado por Github Copilot Chat
